interface IShouldDisplayMainsInServingsArgs {
  isFlexServings: boolean;
  numServings: number;
}

/**
 * Whether meal-plan dish selection should count mains by the serving rather than by the main.
 *
 * True only for flex plans of two or more servings. Control and a one-serving flex plan both
 * count in mains — at one serving per meal a serving *is* a main, so flex v1's serving framing
 * cost those users clarity without buying them anything.
 *
 * Mechanics are a separate question: a one-serving flex plan still has no cap on mains and still
 * charges per serving, so callers deciding policy want `useIsUserInFlexServings` rather than this.
 *
 * Tests `numServings !== 1` rather than `> 1` because `clearMealPlanConfig` zeroes the cart store,
 * and reading that as a one-serving plan would show mains framing to a multi-serving user
 * mid-navigation.
 */
export const shouldDisplayMainsInServings = ({
  isFlexServings,
  numServings,
}: IShouldDisplayMainsInServingsArgs): boolean => isFlexServings && numServings !== 1;
